import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useRef } from 'react';
import { useDrag, useDrop } from 'react-dnd';
import './BoxObi.css';
import { useWindowWidth } from '../../../../../HOC/useWindowWidth';
const BoxObi = ({ obi, moveEpi, index, id }) => {
  const ref = useRef(null);

  const [, drop] = useDrop({
    accept: 'EPI',
    hover(item, monitor) {
      if (!ref.current) {
        return;
      }
      const dragIndex = item.index;
      const hoverIndex = index;
      if (dragIndex === hoverIndex) {
        return;
      }
      moveEpi(dragIndex, hoverIndex);
      item.index = hoverIndex;
    },
  });

  const [{ isDragging }, drag] = useDrag({
    type: 'groupMember',
    item: { type: 'EPI', id, index },
    collect: monitor => ({
      isDragging: monitor.isDragging(),
    }),
  });

  const opacity = isDragging ? 0 : 2;
  drag(drop(ref));

  const currWidth = useWindowWidth();

  return (
    <>
      {currWidth <= 1024 && isDragging ? (
        <div
          className="boxObiContainerDraggable shadow-inset-card"
          ref={ref}
          style={{ ...opacity }}
        >
          <div className="obiLabel">{obi.deviceId}</div>
          <div className="obiInfo draggable-card-header">drop to place</div>
        </div>
      ) : (
        <div className="boxObiContainerDraggable" ref={ref} style={{ ...opacity }}>
          <div className="obiInfo">
            <div className="infoLabel">
              <FontAwesomeIcon fixedWidth className="labelIcon" icon="microchip" />
              <h5>MAC Address</h5>
            </div>
            <span>{obi.macAddress || 'N/A'}</span>
          </div>
        </div>
      )}
    </>
  );
};

export default BoxObi;
